module.exports = "/images/Romain.jpg?647b310b0980f95bfd777cdc6d43a032";